import login from "@/router/pages/agent/auth/login";
import signup from "@/router/pages/agent/auth/signup";
import forgotPassword from "@/router/pages/agent/auth/forgotPassword";

const agentAuth = [...login, ...signup, ...forgotPassword];

export default agentAuth;
